import { render, staticRenderFns } from "./AbsenceUnJustifiedWidget.vue?vue&type=template&id=53d6bf73&scoped=true&"
import script from "./AbsenceUnJustifiedWidget.vue?vue&type=script&lang=js&"
export * from "./AbsenceUnJustifiedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6bf73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53d6bf73')) {
      api.createRecord('53d6bf73', component.options)
    } else {
      api.reload('53d6bf73', component.options)
    }
    module.hot.accept("./AbsenceUnJustifiedWidget.vue?vue&type=template&id=53d6bf73&scoped=true&", function () {
      api.rerender('53d6bf73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/widgets/AbsenceUnJustifiedWidget.vue"
export default component.exports